module.exports = __webpack_public_path__ + "static/w15-20fa30525b2b68a86e141cae343e5e91.jpg";